'use strict';

bbw.model.UserSettings = ngtk.model.Item.extend({

    _isLoaded: undefined,

    load: function(reload) {
        if (this._isLoaded && !reload) {
            return this.$q.when(true);
        }
        return this._loadFromApi('get', 'user/settings/get').then(this._handleResponse.bind(this));
    },

    update: function(newSettings) {
        if (angular.isObject(newSettings)) {
            angular.extend(this._data, newSettings);
        }
        return this._loadFromApi('post', 'user/settings/update', this._data).then(this._handleResponse.bind(this));
    },

    _handleResponse: function(response) {
        if (angular.isObject(response) && angular.isObject(response.settings)) {
            this._setFromApiResult(response.settings);
            this._isLoaded = true;
        } else {
            this.$q.reject('internal_error');
        }
    }

});